// Which site is rendered at /, /about and in the header.
//   'security' -> Security and Secure AI Adoption site (src/views/security, src/components/security)
//   'legacy'   -> the original service-based site (src/views/home, src/views/about, partials/*Menu)
//
// This is the single switch. Change the default below, or set VUE_APP_SITE_MODE in .env
// (restart `npm run serve` after changing .env). Legacy files are never modified by the
// security site, so flipping this back restores the old pages exactly.
export const SITE_MODE = process.env.VUE_APP_SITE_MODE || 'security';

export const isSecurityMode = SITE_MODE === 'security';
